export const ReactAceThemes = [
    "monokai",
    "github",
    "tomorrow",
    "twilight",
    "cobalt",
    "clouds",
    "dreamweaver",
]